import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imIssueViewJournal', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/issue_view/journal/journal.html'),
        controller: 'IssueViewJournalController',
        controllerAs: 'IssueViewJournalCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_view/journal/journal.component.ts